import React from 'react';
import { BreadcrumbFlyoutProps } from './BreadcrumbFlyout';
import { BreadcrumbNavItem } from '../../../types/api/NavItem';
import { BreadCrumbItem } from './BreadCrumbItem';

export type BreadcrumbItemProps = {
  navItem?: BreadcrumbNavItem;
  siblings?: BreadcrumbFlyoutProps;
  index: number;
  hasReadRestrictions: boolean;
};

export function BreadcrumbListItem({
  siblings = undefined,
  navItem = undefined,
  index,
  hasReadRestrictions,
}: BreadcrumbItemProps) {
  if (!navItem) {
    return null;
  }

  return (
    <li className="breadcrumb__listelement">
      <BreadCrumbItem navItem={navItem} siblings={siblings} index={index} hasReadRestrictions={hasReadRestrictions} />
    </li>
  );
}
